import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/persetujuan-laparotomi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/persetujuan-laparotomi/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/persetujuan-laparotomi`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/persetujuan-laparotomi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getMasters() {
  const response = await http.getData(`/persetujuan-laparotomi/masters`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http.putData(`/persetujuan-laparotomi/${id}/sign-dpjp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signSaksiRs(id: number, data) {
  const response = await http.putData(`/persetujuan-laparotomi/${id}/sign-saksi-rs`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markPenyetuju(id: number, data) {
  const response = await http.putData(`/persetujuan-laparotomi/${id}/mark-penyetuju`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markSaksiKeluarga(id: number, data) {
  const response = await http.putData(`/persetujuan-laparotomi/${id}/mark-saksi-keluarga`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/persetujuan-laparotomi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/persetujuan-laparotomi/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  getMasters,
  signDpjp,
  signSaksiRs,
  markPenyetuju,
  markSaksiKeluarga,
  destroy,
  print
};
